function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React, { memo } from 'react';
import styled from 'styled-components';
import { border, borderRadius, height, width } from 'styled-system';
import Box from '../Box';
const StyledSuffix = styled(Box).withConfig({
  displayName: "Suffix__StyledSuffix",
  componentId: "sc-iv461i-0"
})(["", " ", " ", " ", " white-space:nowrap;border-left:none;border-top-left-radius:0;border-bottom-left-radius:0;"], border, borderRadius, height, width);
const Suffix = /*#__PURE__*/memo(_ref => {
  let {
    as = 'span',
    bg = 'gray.1',
    border = 'default',
    borderRadius = 'corner',
    display = 'block',
    height = rem(40),
    px = 3,
    py = 2,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSuffix, _extends({
    as: as,
    bg: bg,
    border: border,
    borderRadius: borderRadius,
    display: display,
    height: height,
    px: px,
    py: py
  }, props));
});
Suffix.propTypes = {
  ...Box.propTypes,
  ...borderRadius.propTypes,
  ...height.propTypes
};
Suffix.displayName = 'Suffix';
export default Suffix;